// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"155":"cfbd368b668bfa969c61","175":"2b4db827516bf34adac5","231":"6c7686233521f2e51162","532":"b0fdec28c7f3d462a9cd","678":"335b64364b18223e7fc5"}[chunkId] + ".js";
};